import React from "react"
import { Select } from "antd"
import { AntdFormItem } from "../AntdFormItem/AntdFormItem"
import { RegisterStudentCourse } from "./types"
import { referralSources } from "./enums"
import { MappedCourse } from "../../lib/prismic/MappedCourse"
import { FormikErrors, FormikTouched } from "formik"

const commonCol = {
  labelCol: {
    span: 24 - 10
  },
  wrapperCol: {
    span: 10
  }
}

export const ReferralSourceFormItem = ({ values, errors, touched, setFieldValue, handleBlur }: Props) => {
  return (
    <AntdFormItem<RegisterStudentCourse> name="referralSource" label="Jak jste se o náš dozvěděli?" errors={errors} touched={touched} {...commonCol}>
      <Select value={values.referralSource} onChange={(value) => setFieldValue("referralSource", value, true)} onBlur={handleBlur}>
        {referralSources.map((s) => (
          <Select.Option key={s} value={s}>
            {s}
          </Select.Option>
        ))}
      </Select>
    </AntdFormItem>
  )
}

interface Props {
  values: RegisterStudentCourse
  course: MappedCourse
  errors: FormikErrors<RegisterStudentCourse>
  touched: FormikTouched<RegisterStudentCourse>
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  handleBlur: React.FocusEventHandler<HTMLElement>
}
